import React from 'react';
import WebinarComponent from 'components/webinar';

export default function Webinar(props) {
  return <WebinarComponent {...props.location} />;
}
